import { render, staticRenderFns } from "./RankForm.vue?vue&type=template&id=c48f6254&scoped=true"
import script from "./RankForm.vue?vue&type=script&lang=js"
export * from "./RankForm.vue?vue&type=script&lang=js"
import style0 from "./RankForm.vue?vue&type=style&index=0&id=c48f6254&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c48f6254",
  null
  
)

export default component.exports